import { useQuery } from "react-query";
import { CompanyFeatures } from "v2/domain/common/enums/CompanyFeatures";
import findCompanyFeatures from "v2/domain/common/useCases/findCompanyFeatures";

const useGetCompanyFeatures = () =>
  useQuery(["useGetCompanyFeatures"], findCompanyFeatures, {
    initialData: {} as Record<CompanyFeatures, boolean>,
  });

export default useGetCompanyFeatures;
